import { render, staticRenderFns } from "./hover-overlay.vue?vue&type=template&id=128f52dc&scoped=true&"
import script from "./hover-overlay.vue?vue&type=script&lang=ts&"
export * from "./hover-overlay.vue?vue&type=script&lang=ts&"
import style0 from "./hover-overlay.vue?vue&type=style&index=0&id=128f52dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f52dc",
  null
  
)

export default component.exports